import * as types from '../../index.types';

// Action creators for the seven VMS modules that hang off a visitor record.
// The visitor master itself has its own file (VisitorAction).
//
// Every creator takes one `data` object; the request layer picks the fields it
// needs out of it. `onSuccess` / `onError` callbacks travel in the same object
// and are stripped before the request goes out.

const make = (type) => (data) => ({ type, data });

/* ------------------------------------------------------------- visits */
export const getVisitsList = make(types.SOCIETY_GET_VISITS_LIST);
export const getVisitDetails = make(types.SOCIETY_GET_VISIT_DETAILS);
export const createVisit = make(types.SOCIETY_CREATE_VISIT);
export const updateVisit = make(types.SOCIETY_UPDATE_VISIT);
export const deleteVisit = make(types.SOCIETY_DELETE_VISIT);
export const approveVisit = make(types.SOCIETY_APPROVE_VISIT);
export const rejectVisit = make(types.SOCIETY_REJECT_VISIT);
export const verifyVisitOtp = make(types.SOCIETY_VERIFY_VISIT_OTP);
export const checkInVisit = make(types.SOCIETY_CHECK_IN_VISIT);
export const checkOutVisit = make(types.SOCIETY_CHECK_OUT_VISIT);

/* ------------------------------------------------------ pre-approvals */
export const getPreApprovalsList = make(types.SOCIETY_GET_PRE_APPROVALS_LIST);
export const getPreApprovalDetails = make(types.SOCIETY_GET_PRE_APPROVAL_DETAILS);
export const createPreApproval = make(types.SOCIETY_CREATE_PRE_APPROVAL);
export const updatePreApproval = make(types.SOCIETY_UPDATE_PRE_APPROVAL);
export const deletePreApproval = make(types.SOCIETY_DELETE_PRE_APPROVAL);

/* -------------------------------------------------------- gate passes */
export const getGatePassesList = make(types.SOCIETY_GET_GATE_PASSES_LIST);
export const getGatePassDetails = make(types.SOCIETY_GET_GATE_PASS_DETAILS);
export const createGatePass = make(types.SOCIETY_CREATE_GATE_PASS);
export const updateGatePass = make(types.SOCIETY_UPDATE_GATE_PASS);
export const deleteGatePass = make(types.SOCIETY_DELETE_GATE_PASS);
export const revokeGatePass = make(types.SOCIETY_REVOKE_GATE_PASS);

/* ------------------------------------------------------- deliveries */
export const getDeliveriesList = make(types.SOCIETY_GET_DELIVERIES_LIST);
export const getDeliveryDetails = make(types.SOCIETY_GET_DELIVERY_DETAILS);
export const createDelivery = make(types.SOCIETY_CREATE_DELIVERY);
export const updateDelivery = make(types.SOCIETY_UPDATE_DELIVERY);
export const deleteDelivery = make(types.SOCIETY_DELETE_DELIVERY);
export const completeDelivery = make(types.SOCIETY_COMPLETE_DELIVERY);

/* -------------------------------------------------------------- cabs */
export const getCabsList = make(types.SOCIETY_GET_CABS_LIST);
export const getCabDetails = make(types.SOCIETY_GET_CAB_DETAILS);
export const createCab = make(types.SOCIETY_CREATE_CAB);
export const updateCab = make(types.SOCIETY_UPDATE_CAB);
export const deleteCab = make(types.SOCIETY_DELETE_CAB);
export const completeCab = make(types.SOCIETY_COMPLETE_CAB);

/* ----------------------------------------------------- activity logs */
export const getVmsActivityLogs = make(types.SOCIETY_GET_VMS_ACTIVITY_LOGS);
export const exportVmsActivityLogs = make(types.SOCIETY_EXPORT_VMS_ACTIVITY_LOGS);

/* ---------------------------------------------------------- settings */
export const getVmsSettings = make(types.SOCIETY_GET_VMS_SETTINGS);
export const updateVmsSettings = make(types.SOCIETY_UPDATE_VMS_SETTINGS);
